/**
 * Normalize penalty fields from fixture/market score shapes used across the app.
 */
export function getPenaltyFromScore(score) {
  if (!score) return null;
  const home = score.penaltyHome ?? score.penaltyHomeGoals;
  const away = score.penaltyAway ?? score.penaltyAwayGoals;
  if (home == null || away == null) return null;
  return { home, away };
}
